import { render, staticRenderFns } from "./TeacherList.vue?vue&type=template&id=f9502540&scoped=true&"
import script from "./TeacherList.vue?vue&type=script&lang=js&"
export * from "./TeacherList.vue?vue&type=script&lang=js&"
import style0 from "./TeacherList.vue?vue&type=style&index=0&id=f9502540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9502540",
  null
  
)

component.options.__file = "TeacherList.vue"
export default component.exports